import React, { useEffect, useState } from "react";
import moment from "moment";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import Modal from "react-modal";
import NoDataFound from "components/NoDataFound";
import { handleError } from "utils";
import { showSuccess } from "services/toast.service";
import RemoveButton from "components/Button/RemoveButton";
import UpdateButton from "components/Button/UpdateButton";

import Loader from "components/Loader";
import { API_BASE_URL } from "config/constants";
import { getAccessToken } from "utils";
import { getUser } from "utils";

const Clients = ({ color }) => {
  const history = useHistory();

  const data = [];
  const [client, setclient] = useState(data);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [selectedClientId, setSelectedClientId] = useState(0);
  const [gettingData, setGettingData] = useState(false);
  const [updatedata, setupdatedata] = useState(false);
  const user = getUser();
  const [keyword, setKeyword] = useState("");

  const [passwordModalIsOpen, setPasswordModalIsOpen] = useState(false);
  const [passwordClient, setPasswordClient] = useState(null);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordSubmitClick, setPasswordSubmitClick] = useState(false);
  const [changePasswordLoading, setChangePasswordLoading] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const getClient = async () => {
    try {
      setGettingData(true);
      const responce = await axios.get(`${API_BASE_URL}/user?page=1`, {
        method: "GET",
        headers: {
          authorization: getAccessToken(),
        },
      });
      setGettingData(false);

      const apiData = responce.data;

      setclient(apiData.result.data.result);
    } catch (error) {
      setGettingData(false);
      handleError(error);
    }
  };
  useEffect(() => {
    getClient();
  }, []);

  ///Delete
  const deleteClient = async (id) => {
    try {
      setSelectedClientId(id);
      setDeleteLoading(true);
      const deleteResponse = await axios.delete(`${API_BASE_URL}/user`, {
        headers: {
          "Content-Type": "application/json",
          authorization: getAccessToken(),
        },
        data: {
          id: id,
        },
      });

      setSelectedClientId(0);
      setDeleteLoading(false);
      showSuccess(deleteResponse?.data?.result?.message);
      getClient();
    } catch (error) {
      setSelectedClientId(0);
      setDeleteLoading(false);
      handleError(error);
    }
  };

  const goToUpdateData = (data) => {
    history.push("/admin/update-client", {
      data,
    });
  };

  const customStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.4)",
      zIndex: 1000,
    },
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      transform: "translate(-50%, -50%)",
      width: "calc(100% - 2rem)",
      maxWidth: "28rem",
      padding: 0,
      border: "none",
      borderRadius: "0.5rem",
      overflow: "hidden",
    },
  };

  const openPasswordModal = (cli) => {
    setPasswordClient(cli);
    setNewPassword("");
    setConfirmPassword("");
    setPasswordSubmitClick(false);
    setShowNewPassword(false);
    setShowConfirmPassword(false);
    setPasswordModalIsOpen(true);
  };

  const closePasswordModal = () => {
    setPasswordModalIsOpen(false);
    setPasswordClient(null);
  };

  const handleChangePassword = async () => {
    setPasswordSubmitClick(true);
    if (!newPassword || newPassword !== confirmPassword) return;
    try {
      setChangePasswordLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/user/change-password`,
        {
          id: passwordClient._id,
          password: newPassword,
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: getAccessToken(),
          },
        }
      );
      setChangePasswordLoading(false);
      showSuccess(response?.data?.result?.message);
      closePasswordModal();
    } catch (error) {
      setChangePasswordLoading(false);
      handleError(error);
    }
  };

  const filterData = (data) => {
    if (!keyword) return true;
    if (
      data.name.toLowerCase().includes(keyword.toLowerCase()) ||
      data.email.toLowerCase().includes(keyword.toLowerCase()) ||
      data.role.toLowerCase().includes(keyword.toLowerCase()) ||
      data.skype.toLowerCase().includes(keyword.toLowerCase()) ||
      data.website.toLowerCase().includes(keyword.toLowerCase()) ||
      data.companyName.toLowerCase().includes(keyword.toLowerCase()) ||
      data.assignedTo.toLowerCase().includes(keyword.toLowerCase())
    ) {
      return true;
    }
    return false;
  };

  const handleKeywordChange = (event) => {
    setKeyword(event.target.value);
  };

  return (
    <>
      <div
        className={
          "relative flex flex-col min-w-0 b reak-words w-full mb-6 shadow-lg rounded " +
          (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
        }
      >
        <div className="rounded-t mb-0 px-4 py-3 border-0 ">
          <div className="flex flex-wrap items-center">
            <div className="relative flex justify-items-start gap-2 items-center w-full px-4 max-w-full flex-grow flex-1">
              {" "}
              <h3
                className={
                  "font-semibold text-lg  " +
                  (color === "light" ? "text-blueGray-700" : "text-white")
                }
              >
                Clients
              </h3>
              <Loader loading={gettingData} />
            </div>
            <Link to="/admin/add-client">
              <button
                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                type="button"
              >
                Add New Client
              </button>
            </Link>
          </div>
        </div>
        <div className="flex px-4 pb-3">
          <input
            type="text"
            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full lg:w-1/3 ease-linear transition-all duration-150"
            placeholder="Search.."
            name="clicks"
            value={keyword}
            onChange={handleKeywordChange}
          />
        </div>
        <div className="block w-full overflow-x-auto">
          {/* Projects table */}
          <table className="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Name
                </th>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Email
                </th>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Role
                </th>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Skype
                </th>

                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Website
                </th>

                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Company
                </th>

                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Assigned To
                </th>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Created On
                </th>

                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Updated On
                </th>

                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Last Login
                </th>

                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Status
                </th>

                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {client[0] ? (
                <>
                  {client.filter(filterData).map((cli) => {
                    return (
                      <tr>
                        <th className="  border-t-0 align-middle  text-left border-l-0 border-r-0 text-xs whitespace-nowrap p-4 ">
                          <span
                            className={
                              "ml-3 font-bold " +
                              +(color === "light"
                                ? "text-blueGray-600"
                                : "text-white")
                            }
                          >
                            {cli.name || "-"}
                          </span>
                        </th>
                        <td className=" border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          {cli.email || "-"}
                        </td>
                        <td className="border-t-0 px-6 alig n-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          {cli.role || "-"}
                        </td>
                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          {cli.skype || "-"}{" "}
                        </td>

                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          {cli.website || "-"}{" "}
                        </td>
                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          {cli.companyName || "-" }{" "}
                        </td>
                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          {cli.assignedTo || "-"}{" "}
                        </td>

                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">
                            <span className="mr-2">
                              {moment(cli.createdAt).format("llll")}
                            </span>
                          </div>
                        </td>

                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">
                            <span className="mr-2">
                              {moment(cli.updatedAt).format("llll")}
                            </span>
                          </div>
                        </td>

                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">
                            <span className="mr-2">
                              {cli.lastLogin
                                ? moment(cli.lastLogin).format("lll")
                                : "-"}
                            </span>
                          </div>
                        </td>

                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">
                            <span className="mr-2">
                              {cli.isActive ? (
                                <>
                                  <i className="fas fa-circle text-green-500 mr-2"></i>{" "}
                                </>
                              ) : (
                                <>
                                  {" "}
                                  <i className="fas fa-circle text-yellow-500 mr-2"></i>{" "}
                                </>
                              )}
                            </span>
                          </div>
                        </td>
                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">
                            <UpdateButton onClick={() => goToUpdateData(cli)} />

                            {user.role === "Admin" && (
                              <button
                                title="Change Password"
                                onClick={() => openPasswordModal(cli)}
                                className="fas fa-key mr-2 text-sm bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                              >
                                {" "}
                              </button>
                            )}

                            {user.role === "Admin" && <RemoveButton
                              onClick={() => deleteClient(cli._id)}
                              loading={
                                deleteLoading && selectedClientId === cli._id
                              }
                            />}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </>
              ) : (
                <td colSpan={13}>
                  <NoDataFound />
                </td>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Modal
        isOpen={passwordModalIsOpen}
        style={customStyles}
        shouldCloseOnEsc
        onRequestClose={closePasswordModal}
        contentLabel="Change Password Modal"
      >
        <div className="flex items-start justify-between px-6 py-4 border-b border-blueGray-200 bg-blueGray-50">
          <div>
            <h3 className="font-semibold text-lg text-blueGray-700">
              Change Password
            </h3>
            <p className="text-sm text-blueGray-500 mt-1">
              {passwordClient?.name} ({passwordClient?.email})
            </p>
          </div>
          <button
            type="button"
            className="text-blueGray-400 hover:text-blueGray-600 text-xl leading-none outline-none focus:outline-none ml-4"
            onClick={closePasswordModal}
          >
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="px-6 py-5">
          <div className="relative w-full mb-4">
            <label
              className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
              htmlFor="new-password"
            >
              New Password
            </label>
            <div style={{ position: "relative" }}>
              <input
                id="new-password"
                type={showNewPassword ? "text" : "password"}
                value={newPassword}
                autoComplete="new-password"
                placeholder="Enter new password"
                className="border border-blueGray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm focus:outline-none focus:ring focus:border-lightBlue-500 w-full ease-linear transition-all duration-150"
                style={{ paddingRight: "2.5rem" }}
                name="newPassword"
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <button
                type="button"
                tabIndex={-1}
                title={showNewPassword ? "Hide password" : "Show password"}
                className="text-blueGray-400 hover:text-blueGray-600 outline-none focus:outline-none"
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "0.75rem",
                  transform: "translateY(-50%)",
                }}
                onClick={() => setShowNewPassword((show) => !show)}
              >
                <i
                  className={
                    "fas " + (showNewPassword ? "fa-eye-slash" : "fa-eye")
                  }
                ></i>
              </button>
            </div>
            {passwordSubmitClick && !newPassword && (
              <div className="text-red-500 text-xs mt-1 font-semibold">
                Password is required!
              </div>
            )}
          </div>
          <div className="relative w-full">
            <label
              className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
              htmlFor="confirm-password"
            >
              Confirm Password
            </label>
            <div style={{ position: "relative" }}>
              <input
                id="confirm-password"
                type={showConfirmPassword ? "text" : "password"}
                value={confirmPassword}
                autoComplete="new-password"
                placeholder="Re-enter new password"
                className="border border-blueGray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm focus:outline-none focus:ring focus:border-lightBlue-500 w-full ease-linear transition-all duration-150"
                style={{ paddingRight: "2.5rem" }}
                name="confirmPassword"
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <button
                type="button"
                tabIndex={-1}
                title={showConfirmPassword ? "Hide password" : "Show password"}
                className="text-blueGray-400 hover:text-blueGray-600 outline-none focus:outline-none"
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "0.75rem",
                  transform: "translateY(-50%)",
                }}
                onClick={() => setShowConfirmPassword((show) => !show)}
              >
                <i
                  className={
                    "fas " + (showConfirmPassword ? "fa-eye-slash" : "fa-eye")
                  }
                ></i>
              </button>
            </div>
            {passwordSubmitClick &&
              newPassword &&
              newPassword !== confirmPassword && (
                <div className="text-red-500 text-xs mt-1 font-semibold">
                  Passwords do not match!
                </div>
              )}
          </div>
        </div>
        <div className="flex items-center justify-end px-6 py-4 border-t border-blueGray-200 bg-blueGray-50">
          <button
            className="text-blueGray-500 font-bold uppercase text-xs px-4 py-2 rounded outline-none focus:outline-none mr-2 ease-linear transition-all duration-150"
            type="button"
            onClick={closePasswordModal}
          >
            Cancel
          </button>
          <button
            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150 disabled:opacity-50"
            type="button"
            disabled={changePasswordLoading}
            onClick={handleChangePassword}
          >
            {changePasswordLoading ? "Changing..." : "Change Password"}
          </button>
        </div>
      </Modal>
    </>
  );
};

export default Clients;
